import { render } from "./adPreferencesInput.vue?vue&type=template&id=bfb99a76"
import script from "./adPreferencesInput.vue?vue&type=script&lang=js"
export * from "./adPreferencesInput.vue?vue&type=script&lang=js"

import "./adPreferencesInput.vue?vue&type=style&index=0&id=bfb99a76&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__